import { Link } from "react-router-dom";
import { PageHeader, PageSection } from "@anyseal/ui";
import { useI18n } from "../i18n";

export function LegalPage({ publicView = false }: { publicView?: boolean }) {
  const { locale } = useI18n();

  const content = (
    <div className="portal-page-grid portal-legal">
      <PageHeader
        eyebrow={locale === "zh-CN" ? "账户" : "Account"}
        title={locale === "zh-CN" ? "法律与隐私" : "Legal & privacy"}
        description={
          locale === "zh-CN"
            ? "LonMax AI 由 Lonmax AI Compute Technology 运营，对数据处理与服务边界保持透明。"
            : "LonMax AI is operated by Lonmax AI Compute Technology and is transparent about data handling and service boundaries."
        }
      />

      <PageSection
        title={locale === "zh-CN" ? "责任主体" : "Responsible entity"}
      >
        <p>
          {locale === "zh-CN"
            ? "LonMax AI 平台及相关服务由 Lonmax AI Compute Technology 运营。服务条款与隐私政策项下的义务由该主体承担；对外法律文本以该主体名义发布。"
            : "The LonMax AI platform and related services are operated by Lonmax AI Compute Technology. Obligations under the terms of service and privacy policy are borne by this entity, and legal documents are published in its name."}
        </p>
      </PageSection>

      <PageSection
        title={locale === "zh-CN" ? "隐私基线" : "Privacy baseline"}
      >
        <p>
          {locale === "zh-CN"
            ? "常规诊断不会保存原始提示词、响应正文、上传内容、Authorization 或 Cookie。运行日志默认保留 30 天；请求元数据与用量摘要默认保留 180 天；管理操作与安全审计默认保留 365 天；账务记录默认保留 7 年，当地法律要求更长时从其规定。"
            : "Routine diagnostics do not retain raw prompts, response bodies, uploads, Authorization, or cookies. Runtime logs are retained for 30 days by default; request metadata and usage summaries for 180 days; admin operations and security audits for 365 days; financial records for 7 years by default, or longer where local law requires."}
        </p>
      </PageSection>

      <PageSection
        title={locale === "zh-CN" ? "数据删除与账户注销" : "Data deletion & account closure"}
      >
        <p>
          {locale === "zh-CN"
            ? "组织管理员可以缩短普通请求记录的保留期，但不能缩短法律要求的账务记录、平台安全审计或正在调查的数据。账户注销采用先停用、再按保留策略删除或匿名化的流程；法律保留数据与已注销账户之间只保留必要、受控的关联。"
            : "Organization administrators can shorten the retention of ordinary request records, but cannot shorten legally required financial records, platform security audits, or data under active investigation. Account closure deactivates the account first, then deletes or anonymizes data according to retention policy; only necessary, controlled links between legally retained data and closed accounts remain."}
        </p>
      </PageSection>

      <PageSection
        title={locale === "zh-CN" ? "服务条款摘要" : "Terms summary"}
      >
        <p>
          {locale === "zh-CN"
            ? "用户需要妥善保管 API 密钥、遵守上游模型供应商的使用政策，并对自己的应用和内容负责。正式服务条款、隐私政策及地区性补充文件将在公开发布前由法律顾问确认；当前页面不构成最终法律文本。"
            : "Customers must protect their API keys, follow upstream model providers' usage policies, and remain responsible for their own applications and content. Final terms of service, privacy policy, and regional addenda will be reviewed by legal counsel before public launch; this page is not the final legal instrument."}
        </p>
      </PageSection>

      <PageSection
        title={locale === "zh-CN" ? "联系我们" : "Contact"}
      >
        <p>
          {locale === "zh-CN"
            ? "隐私、账务或安全问题请通过正式支持渠道提交，并附上 LonMax AI 请求 ID；不要发送 API 密钥或用户内容。"
            : "Submit privacy, billing, or security questions through the official support channel with a LonMax AI request ID. Never send API keys or user content."}
        </p>
      </PageSection>

      {publicView ? (
        <Link to="/login">
          {locale === "zh-CN" ? "返回登录" : "Back to sign in"}
        </Link>
      ) : null}
    </div>
  );

  return publicView ? <main className="portal-main">{content}</main> : content;
}
